import cn from 'classnames';

const CitySelectionItem = (props) => {
    const {
        id, name, distance, selected, pdf
    } = props;
    const className = cn(
        'city-selection-item',
        {
            'city-selection-item--selected': selected
        }
    );
    const distanceTemplate = distance ? `<div class="city-selection-item__distance">${distance}км</div>` : '';
    return `
        <div class="${className}" data-id="${id}">
            <div class="city-selection-item__wrapper">
                <div class="city-selection-item__name">${name}</div>
                ${distanceTemplate}
            </div>
            <a href="${pdf}" class="city-selection-item__pdf">Договор</a>
        </div>
    `;
};

export default CitySelectionItem;
